import { useNavigate } from "react-router-dom";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface CardProductProps {
   srcImage: string;
   title: string;
   text: string;
   link: string;
}

export default function CardProduct({ srcImage, title, text, link }: CardProductProps) {
   const navigate = useNavigate();
   return (
      <div className="bg-white border border-[#EFF5F9] rounded-[6px] lg:rounded-[10px] 2xl:rounded-xl shadow-[0px_0px_30px_11px_rgba(167,210,236,0.20)] h-full relative flex flex-col justify-between items-center gap-2 lg:gap-5 2xl:gap-7 p-4 lg:p-6 2xl:p-8">
         <img
            src={srcImage}
            alt={title}
            className="h-[80px] w-[100px] lg:h-[178px] lg:w-[195px] 2xl:h-[240px] 2xl:w-[280px] object-contain"
         />
         <div className="flex flex-col w-full  gap-1 2xl:gap-2">
            <h2 className="text-[#273167] text-xs lg:leading-tight lg:text-xl 2xl:text-2xl font-montserrat font-semibold lg:font-bold lg:h-auto mb-3 lg:mb-0 lg:text-left">{title}</h2>
            <p className="text-[#273167] text-[11px] leading-3 lg:leading-normal lg:text-lg 2xl:text-xl font-montserrat lg:font-medium">{text}</p>
         </div>
         <button
            onClick={() => navigate(link)} // Возвращаемся на предыдущую страницу
            className="pr-px lg:pr-1 pl-1.5 py-0.5 lg:pl-3 xl:pl-3.5 lg:py-1 flex items-center gap-0.5 lg:gap-2 bg-[#354598] hover:bg-[#2F3E8B] text-sm lg:text-xl font-medium lg:font-bold 2xl:text-2xl text-white rounded-lg lg:rounded-2xl transition-all duration-300 hover:shadow-md"
         >
            Подробнее
            <ChevronRightIcon sx={{
               fontSize: {
                  xs: '1.3rem',
                  lg: '2.5rem',
                  xl: '3.0rem',
               }
            }} />
         </button>
      </div>
   );
}
